"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = exports.SaveButton = exports.RejectAllButton = exports.PreferenceTitle = exports.PreferencesContainer = exports.PreferenceItem = exports.PreferenceInfo = exports.PreferenceDescription = exports.ModalContent = exports.Header = exports.Description = exports.CookieSettingsModal = exports.CloseButton = exports.ActionsContainer = exports.AcceptAllButton = void 0;
const reactjs_popup_1 = __importDefault(require("reactjs-popup"));
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../../assets/styles/colors");
const media_1 = require("../../../../utils/media");
const Button_style_1 = require("../../../atoms/Button/Button.style");
const CookieSettingsModal = (0, styled_components_1.default)(reactjs_popup_1.default) `
  width: 100%;

  &-overlay {
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  &-content {
    background-color: ${colors_1.white};
    opacity: 1;
    border-radius: 12px;
    position: relative;
    padding: 2rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    max-width: 600px;
    width: 90vw;
    margin: 0;
    transform: none;
    top: auto;
    left: auto;
    right: auto;
    bottom: auto;

    @media ${media_1.media.mobile} {
      margin: 1rem;
      padding: 1.5rem;
      width: calc(100vw - 2rem);
    }
  }
`;
exports.CookieSettingsModal = CookieSettingsModal;
const ModalContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
exports.ModalContent = ModalContent;
const Header = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${colors_1.gray100};
`;
exports.Header = Header;
const Title = styled_components_1.default.h2 `
  color: ${colors_1.acBlue};
  font-size: 2rem;
  font-weight: 700;
  margin: 0;

  @media ${media_1.media.mobile} {
    font-size: 1.5rem;
  }
`;
exports.Title = Title;
const CloseButton = styled_components_1.default.button `
  border: none;
  background-color: transparent;
  cursor: pointer;

  body:not(.user-is-tabbing) &:focus-visible {
    outline: none;
  }
`;
exports.CloseButton = CloseButton;
const Description = styled_components_1.default.p `
  color: ${colors_1.gray300};
  font-size: 1.4rem;
  line-height: 1.5;
  margin: 0;
`;
exports.Description = Description;
const PreferencesContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
exports.PreferencesContainer = PreferencesContainer;
const PreferenceItem = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid ${colors_1.gray100};
  border-radius: 8px;
  background-color: ${colors_1.white};

  @media ${media_1.media.mobile} {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
`;
exports.PreferenceItem = PreferenceItem;
const PreferenceInfo = styled_components_1.default.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
exports.PreferenceInfo = PreferenceInfo;
const PreferenceTitle = styled_components_1.default.h3 `
  color: ${colors_1.acBlue};
  font-size: 1.4rem;
  font-weight: 600;
  margin: 0;
`;
exports.PreferenceTitle = PreferenceTitle;
const PreferenceDescription = styled_components_1.default.p `
  color: ${colors_1.gray300};
  font-size: 1.2rem;
  line-height: 1.4;
  margin: 0;
`;
exports.PreferenceDescription = PreferenceDescription;
const ActionsContainer = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid ${colors_1.gray100};

  @media ${media_1.media.mobile} {
    flex-direction: row;
    gap: 0.5rem;
    justify-content: center;
  }
`;
exports.ActionsContainer = ActionsContainer;
const RejectAllButton = (0, styled_components_1.default)(Button_style_1.Button) `
  background-color: ${colors_1.gray100};
  color: ${colors_1.gray300};
  font-weight: 600;
  border: none;
  padding: 0.75rem 2.5rem;
  border-radius: 6px;
  font-size: 0.9rem;
  text-transform: uppercase;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${colors_1.gray600};
  }

  @media ${media_1.media.mobile} {
    padding: 0.6rem 1.5rem;
    font-size: 0.8rem;
  }
`;
exports.RejectAllButton = RejectAllButton;
const SaveButton = (0, styled_components_1.default)(Button_style_1.Button) `
  background-color: ${colors_1.white};
  color: ${colors_1.acBlueDark};
  font-weight: 600;
  border: 2px solid ${colors_1.blue};
  padding: 0.75rem 2.5rem;
  border-radius: 6px;
  font-size: 0.9rem;
  text-transform: uppercase;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;

  &:hover {
    background-color: ${colors_1.acBlue};
    color: ${colors_1.white};
  }

  @media ${media_1.media.mobile} {
    padding: 0.6rem 1.5rem;
    font-size: 0.8rem;
  }
`;
exports.SaveButton = SaveButton;
const AcceptAllButton = (0, styled_components_1.default)(Button_style_1.Button) `
  background-color: transparent;
  color: ${colors_1.acBlue};
  font-weight: 600;
  border: 2px solid ${colors_1.acBlue};
  padding: 0.75rem 2.5rem;
  border-radius: 6px;
  font-size: 0.9rem;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: ${colors_1.acBlue};
    color: ${colors_1.white};
  }

  @media ${media_1.media.mobile} {
    padding: 0.6rem 1.5rem;
    font-size: 0.8rem;
  }
`;
exports.AcceptAllButton = AcceptAllButton;
